export const fetchRates = async () => {
  const res = await fetch("https://api.frankfurter.app/latest?from=USD");

  const data = await res.json();

  return data?.rates || {};
};
